// extracted by mini-css-extract-plugin
export default {"PettGroup":"PettCoupleGroup_PettGroup__cPbh0","PettCoupleGroup":"PettCoupleGroup_PettCoupleGroup__CEII3"};